import Sidebar from "@/components/Sidebar";

export default function Layout({ children }) {
    return (
        <div className="min-h-screen flex bg-paper">
            <Sidebar />
            <main className="flex-1 min-w-0 animate-fade-in" data-testid="main-area">
                {children}
            </main>
        </div>
    );
}
